<template>
  <BaseLoader
    :is-loading="loading"
    :has-data="vacanciesSimilar?.length > 0"
    loading-label="Bezig met ophalen van resultaten..."
    container
  >
    <div class="container">
      <BaseChipTitle
        title="Vergelijkbare"
        chip="vacatures"
        center
        multi-line-medium
      />
      <div class="grid w-full gap-4 md:grid-cols-3">
        <VacancyTile
          v-for="similar in vacanciesSimilar"
          :key="similar.id"
          :vacancy="similar"
        />
      </div>
    </div>
  </BaseLoader>
</template>

<script setup lang="ts">
import type {Vacancy} from '~/graphql/graphql';
import vacancySimilarQuery from '~/graphql/queries/vacancySimilar.gql';

const props = defineProps<{
  vacancy: Vacancy
}>();

const sectorFilter = computed(() => ({
  filters: {
    sector: props.vacancy?.sector?.title ?? '',
    query: props.vacancy.title,
  },
  vacancy: props.vacancy.id,
  per_page: 3,
}));

const {result: vacanciesSimilarResult, loading} = await useQuery(vacancySimilarQuery, sectorFilter);
const vacanciesSimilar = computed<Vacancy[]>(() => vacanciesSimilarResult.value?.vacancySimilar ?? []);
</script>
